import { responsiveModalOpened, type OpenResponsiveModalPayload } from '../../model';

export const openResponsiveModal = (payload: OpenResponsiveModalPayload) => {
    responsiveModalOpened(payload);
};
